import { render, staticRenderFns } from "./userRoleType.vue?vue&type=template&id=6286f8ef&scoped=true&"
import script from "./userRoleType.vue?vue&type=script&lang=js&"
export * from "./userRoleType.vue?vue&type=script&lang=js&"
import style0 from "./userRoleType.vue?vue&type=style&index=0&id=6286f8ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6286f8ef",
  null
  
)

export default component.exports